export default __webpack_public_path__ + "static/media/DSC_7913.817bc49d.jpg";